import React from "react";
import { Reveal } from "./Reveal";
import { LionMark } from "./Logo";
import { useLang } from "../i18n";

export default function Vision() {
  const { t } = useLang();
  return (
    <section id="vision" className="section-pad relative overflow-hidden bg-ink">
      <div className="pointer-events-none absolute -right-24 top-1/2 -translate-y-1/2 opacity-[0.06]">
        <LionMark size={520} />
      </div>

      <div className="container-luxe relative">
        <Reveal className="mb-14 text-center">
          <p className="overline">{t.vision.overline}</p>
        </Reveal>

        <div className="grid gap-12 lg:grid-cols-2">
          <Reveal>
            <div className="border-t border-gold/20 pt-8">
              <h3 className="font-serif text-3xl text-gold-gradient md:text-4xl">{t.vision.vtitle}</h3>
              <p className="mt-6 font-serif text-xl font-light leading-relaxed text-white/80 md:text-2xl">
                {t.vision.vtext}
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="border-t border-gold/20 pt-8">
              <h3 className="font-serif text-3xl text-gold-gradient md:text-4xl">{t.vision.mtitle}</h3>
              <p className="mt-6 font-serif text-xl font-light leading-relaxed text-white/80 md:text-2xl">
                {t.vision.mtext}
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
